
import { useEffect } from 'react'
import Select from 'react-select'
import { EnergyStatusDDLAPI, MachEquipmentTypeDDLAPI, UnitTypeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPMachEquipmentTypeDDL = (props) => {
    const { MachEquipmentType, setMachEquipmentType, rowData, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            Flag: Flag,
        }
        dispatch(MachEquipmentTypeDDLAPI({ data }))
    }, [])

    const { MachEquipmentTypeData } = useSelector(state => state.MachEquipmentTypeDDL)

    useEffect(() => {
        handleSTPMachEquipmentTypeDDL()
    }, [MachEquipmentTypeData])

    const handleSTPMachEquipmentTypeDDL = () => {
        // console.log(DeptDDLDataa)
        if (MachEquipmentTypeData && MachEquipmentTypeData.table && MachEquipmentTypeData.table.length > 0) {
            let list = MachEquipmentTypeData.table.map((item, index) => ({
                value: item.m_stP_MachEquipmentTypeID,
                label: item.machEquipmentType,
            }))
            setMachEquipmentType({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_stP_MachEquipmentTypeID : 0,
                Label: Flag === 'Update' ? rowData.machEquipmentType : "Select...",
            })
        }
        else {
            setMachEquipmentType({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Mach Equipment Type</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: MachEquipmentType.ID, label: MachEquipmentType.Label }}
                onChange={(e) => {
                    e ?
                        setMachEquipmentType({ ...MachEquipmentType, ID: e.value, Label: e.label })
                        :
                        setMachEquipmentType({ ...MachEquipmentType, ID: 0, Label: "Select..." })

                }}
                options={MachEquipmentType.DDL}
            />
        </div>
    )
}